import { FINANCE, LEASING, SALES, VerticalType } from '@rma/generic/domain/types';
import { SocialMediaEventType } from './enum/social-media-event-type';

export const SocialMediaEventTypesPerRole: Record<VerticalType, SocialMediaEventType[]> = {
  [FINANCE]: [SocialMediaEventType.MortgageBrokerReview, SocialMediaEventType.Award],
  [SALES]: [SocialMediaEventType.Review, SocialMediaEventType.Listing, SocialMediaEventType.Transaction, SocialMediaEventType.Award],
  [LEASING]: [SocialMediaEventType.LeasingListing, SocialMediaEventType.LeasingTransaction, SocialMediaEventType.LeasingReview],
};
